export const DATE_FORMAT_NO_TIME = "DDMMMYY";
export const DATE_FORMAT = `${DATE_FORMAT_NO_TIME} HH:mm`;
export const DATE_FORMAT_WITH_SECONDS = `${DATE_FORMAT}:ss`;
export const DATE_FORMAT_WITH_TIMEZONE = `${DATE_FORMAT} z`;

export const DATE_FORMAT_READABLE = "ddd Do MMM YYYY";
export const MONTH_FORMAT_READABLE = "MMMM YYYY";

export const MYSQL_DATE_FORMAT = "YYYY-MM-DD";
export const MYSQL_DATE_FORMAT_WITH_TIME = `${MYSQL_DATE_FORMAT} HH:mm:ss`;

// date pickers seems to need their bound values stored in this format
export const DATE_PICKER_FORMAT = MYSQL_DATE_FORMAT;
export const MONTH_PICKER_FORMAT = "YYYY-MM";